import { Module } from "vuex";
import { RootState, getAbsolutePath } from ".";
import { Unsubscribe } from "firebase/auth";
import { collection, onSnapshot, orderBy, query } from "firebase/firestore";
import { db } from "@/firebase";
import { Plugin } from "./types/plugins";

export interface PluginState {
  plugins?: Plugin[];
  privatePlugins?: Plugin[];
}

// スナップショットの解除用
let unsubscribePlugins: (() => void) | undefined = undefined;
let unsubscribePrivatePlugins: (() => void) | undefined = undefined;

export const plugins: Module<PluginState, RootState> = {

  state: {
    plugins: undefined,
    privatePlugins: undefined,
  },

  getters: {
    rootState: (state, getters, rootState) => rootState,
  },

  mutations: {
    // プラグインの設定
    setPlugins(state, params: { plugins: Plugin[], isPrivate?: boolean }) {
      console.log('setPlugins init', params);
      const plugins = params.plugins;
      const isPrivate = params.isPrivate ?? false;
      // console.log('setPlugins plugins', plugins);
      console.log(
        'setPlugins [0].name', plugins[0]?.name,
        'isPrivate', isPrivate
      );
      if (isPrivate) {
        console.log('setPlugins isPrivate');
        state.privatePlugins = plugins;
      } else {
        console.log('setChatSummaries not isPrivate');
        state.plugins = plugins;
      }
    },

    // テンプレートのクリア
    clearPlugins(state, isPrivate = false) {
      console.log('clearPlugins');
      if (isPrivate) {
        state.privatePlugins = undefined;
      } else {
        state.plugins = undefined;
      }
    },

    // onSnapshot処理におけるテンプレートの要素追加
    addPlugins(state, params: { plugins: Plugin[], isPrivate?: boolean }) {
      console.log('addPlugin', params);
      const plugins = params.plugins;
      const isPrivate = params.isPrivate ?? false;
      if (isPrivate) {
        if (state.privatePlugins === undefined) {
          state.privatePlugins = plugins;
        } else {
          state.privatePlugins = [...plugins].concat(state.privatePlugins);
        }
      } else {
        if (state.plugins === undefined) {
          state.plugins = plugins;
        } else {
          state.plugins = [...plugins].concat(state.plugins);
        }
      }
    },

    // onSnapshot処理におけるテンプレートの要素更新処理
    updatePlugins(state, params: { plugins: Plugin[], isPrivate?: boolean }) {
      console.log('updatePlugin', params);
      const updatedPlugins = params.plugins;
      const isPrivate = params.isPrivate ?? false;
      const plugins = isPrivate ? state.privatePlugins : state.plugins;

      if (plugins === undefined) {
        if (isPrivate)
          state.privatePlugins = plugins;
        else
          state.plugins = plugins;
      } else {
        const newPlugins = plugins.map(template => {
          const index = updatedPlugins?.findIndex(
            t => t.id === template.id
          );
          // 一致するものがあれば更新
          if (index !== undefined && index >= 0)
            return updatedPlugins[index];
          else
            // なければそのまま
            return template;
        });
        if (isPrivate)
          state.privatePlugins = newPlugins;
        else
          state.plugins = newPlugins;
      }
    },

    // onSnapshot処理におけるテンプレートの要素削除処理
    removePlugins(state, params: { plugins: Plugin[], isPrivate?: boolean }) {
      console.log('deletePlugin', params);
      const deletedPlugins = params.plugins;
      const isPrivate = params.isPrivate ?? false;
      const plugins = isPrivate ? state.privatePlugins : state.plugins;

      if (plugins === undefined) {
        if (isPrivate)
          state.privatePlugins = plugins;
        else
          state.plugins = plugins;
      } else {
        const newPlugins = plugins.filter(template => {
          const index = deletedPlugins?.findIndex(
            t => t.id === template.id
          );
          // 一致するものがあれば削除
          if (index !== undefined && index >= 0)
            return false;
          else
            // なければそのまま
            return true;
        });
        if (isPrivate)
          state.privatePlugins = newPlugins;
        else
          state.plugins = newPlugins;
      }
    },
  },

  actions: {

    // FirestoreからPluginsの一覧を取得する
    async subscribePlugins({ commit, rootState }, isPrivate = false)
      : Promise<Unsubscribe> {

      console.log('subscribePlugins', isPrivate);
      const colRef = collection(db, getAbsolutePath(isPrivate, rootState, 'plugins'));
      const q = query(colRef, orderBy('created', 'asc'));
      const unsubscribe = onSnapshot(q, (snapshot) => {
        // 更新があった場合に反映
        const addedDocs: Plugin[] = [];
        const updatedDocs: Plugin[] = [];
        const removedDocs: Plugin[] = [];

        console.log('subscribePlugins onSnapshot');
        snapshot.docChanges().forEach((change) => {
          console.log('subscribePlugins onSnapshot change', change);
          const doc = change.doc.data() as Plugin;
          doc.id = change.doc.id;
          switch (change.type) {
            case 'added':
              addedDocs.push(doc);
              break;
            case 'modified':
              updatedDocs.push(doc);
              break;
            case 'removed':
              removedDocs.push(doc);
              break;
            default:
              console.log('change.type is unknown', change.type);
          }
        });
        commit('addPlugins', { plugins: addedDocs, isPrivate });
        commit('updatePlugins', { plugins: updatedDocs, isPrivate });
        commit('removePlugins', { plugins: removedDocs, isPrivate });
      });

      if (isPrivate)
        unsubscribePrivatePlugins = unsubscribe;
      else
        unsubscribePlugins = unsubscribe;
      return unsubscribe;
    },
  }
}
